import React from 'react';
import { Link } from 'react-router-dom';

const AdminPage = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Admin Dashboard</h1>
      <div className="flex justify-center space-x-4">
        <Link to="/admin/roles" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md">
          Manage Roles
        </Link>
        <Link to="/admin/scheduler-status" className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md">
          Scheduler Status
        </Link>
        
      </div>
    </div>
  );
};

export default AdminPage;
